var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AUTH_AXIOS_INSTANCE } from "./authAxiosInstance";
import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Authentication } from "./authentication";
import { getAccessToken } from "./getAccessToken";
const Api = (notRequireAuth = false, signal, baseURL, callExportGrid, apiUrl = "api/Account/GetAccessToken", loginUrl = "/panel/login") => {
    const myAppSettingsObj = window["myAppSettings"];
    const sAlert = withReactContent(Swal);
    const api = AUTH_AXIOS_INSTANCE(signal, baseURL === "mock" ? myAppSettingsObj.REACT_APP_BASE_MOCK_URL : baseURL, callExportGrid);
    api.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
        if (!notRequireAuth) {
            const accessToken = yield getAccessToken(apiUrl, loginUrl);
            if (accessToken) {
                // Authentication.clear();
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
        }
        return config;
    }));
    api.interceptors.response.use((response) => __awaiter(void 0, void 0, void 0, function* () {
        return response;
    }), function (error) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                yield Authentication.clear();
                window.location.href = loginUrl;
            }
            !axios.isCancel(error) &&
                console.log("🚀 ~ file: axios_instance.ts ~ error:", error);
            const expectedError = error.response &&
                error.response.status >= 400 &&
                error.response.status < 500;
            if (expectedError || axios.isCancel(error)) {
                return Promise.reject(error);
            }
            if (error.response && error.response.status === 500) {
                sAlert.fire({
                    title: "درخواست شما با خطا مواجه شد. لطفا بعدا تلاش نمایید. درصورت مشاهده مجدد این خطا، با پشتیبان تماس بگیرید.",
                    confirmButtonText: "تایید",
                    position: "top",
                });
                return Promise.reject(error);
            }
            if (error.response &&
                error.response.status > 500 &&
                error.response.status < 600) {
                sAlert.fire({
                    title: "خطا در برقراری ارتباط! لطفا مجددا تلاش فرمایید. .",
                    confirmButtonText: "تایید",
                    position: "top",
                });
                return Promise.reject(error);
            }
            // در صورتیکه فراخوانی چک کردن برقراری سرور انجام شود نیازی به نمایش این پیغام نمی باشد
            // در صفحه اولیه در صورتی که سرور برقرار نباشد امکان تلاش مجدد قرار داده شده است
            if (error.config.url !== process.env.REACT_APP_CHECK_HEALTH) {
                sAlert.fire({
                    title: "خطا در برقراری ارتباط! لطفا اینترنت خود را بررسی نمایید.",
                    confirmButtonText: "تایید",
                    position: "top",
                });
            }
            return Promise.reject(error);
        });
    });
    return api;
};
export default Api;
